<div class="isg-rolelist-wrapper" [style.height.px]="heightControl()">

  <div *ngIf="showToolbar()" class="isg-rolelist-toolbar">

    <button *ngIf="showSaveButton()" kendoButton type="button" class="isg-button-icon" (click)="onAddClick()">
      <span class="fas fa-plus" title="Create a new role"></span>
    </button>
    <button *ngIf="showSaveButton()" kendoButton type="button" class="isg-button-icon" (click)="onEditClick()" [disabled]="!selectedItem">
      <span class="fas fa-pencil" title="Edit the selected role"></span>
    </button>
    <button *ngIf="showReadOnlyButton()" kendoButton type="button" class="isg-button-icon" (click)="onViewClick()" [disabled]="!selectedItem">
      <span class="fas fa-magnifying-glass" title="Detail"></span>
    </button>
    <button *ngIf="showSaveButton()" kendoButton type="button" class="isg-button-icon" (click)="onCopyClick()" [disabled]="!selectedItem">
      <span class="fas fa-copy" title="Copy the selected role and its permissions. Users assignment should be done afterwards."></span>
    </button>

    <button *ngIf="showDelButton()" kendoButton type="button" class="isg-button-icon" (click)="onDeleteClick()" [disabled]="!selectedItem">
      <span class="fas fa-trash" title="Delete the selected role"></span>
    </button>

    <button *ngIf="showTemplateButton()" kendoButton type="button" class="isg-button-icon" (click)="onTemplateClick()" [disabled]="!selectedItem">
      <span class="fas fa-wand-magic-sparkles" title="Create a copy of the selected role as a template for all companies."></span>
    </button>

  </div>

  <div class="isg-rolelist" isgSizer #listPane="isgSizer">

    <kendo-listview width="100%"
                    [data]="dataItems"
                    [style.height.px]="listPane.height()"
                    (click)="onClickListView($event)"
                    (change)="onChangeListView($event)">

      <ng-template kendoListViewItemTemplate let-dataItem let-index>

        <div *ngIf="(showCheckbox() === true)"
             [ngClass]="{ 'isg-lv-item-selected': dataItem.id == selectedItem?.id, 'isg-lv-chk': (showCheckbox()), 'isg-lv': !(showCheckbox()), 'isg-lv-item' : (true)}">

          <input type="checkbox"
                 [indeterminate]="false"
                 [(ngModel)]="dataItem.checked"
                 [disabled]="showSaveButton() !== true"
                 kendoCheckBox />

          <span (click)="onClickItemEvent(index, dataItem, $event)">
            <span>{{ dataItem.name }}</span>
            <span *ngIf="dataItem.allLicenseUsers" class="isg-roles-lb-all"> all</span>
          </span>
        </div>

        <div *ngIf="!showCheckbox()"
             [ngClass]="{ 'isg-lv-item-selected': dataItem.id == selectedItem?.id, 'isg-lv-chk': (showCheckbox()), 'isg-lv': !(showCheckbox()), 'isg-lv-item' : (true)}"
             (click)="onClickItemEvent(index, dataItem, $event)">

          <span>{{ dataItem.name }}</span>
          <span *ngIf="dataItem.allLicenseUsers" class="isg-roles-lb-all"> all</span>

        </div>

      </ng-template>
    </kendo-listview>

    <app-roles-editor *ngIf="showEditor"
                      [editDataItem]="editDataItem"
                      [isReadOnly]="isViewOnlyEditor"
                      (cancel)="onCancelEditor()"
                      (save)="onSaveEditor($event)">
    </app-roles-editor>

  </div>
</div>
